import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['navbarToggler', 'navbarCollapse']

  toggleNav(event) {
    event.preventDefault()
    this.navbarTogglerTarget.classList.toggle('navbarTogglerActive')
    this.navbarCollapseTarget.classList.toggle('hidden')
  }

  closeNavbarCollapse(_event) {
    this.navbarTogglerTarget.classList.remove('navbarTogglerActive')
    this.navbarCollapseTarget.classList.add('hidden')
  }

  toggleSubMenu(event) {
    event.preventDefault()
    const parentSubmenuItemEl = event.target.closest('.submenu-item')
    parentSubmenuItemEl?.querySelector('.submenu')?.classList?.toggle('hidden')
  }
}
